<div class="min-h-full">
  <!-- Menu lateral / Side-bar -->
  <div class="flex flex-col flex-1">
    <app-header-mini [hidden]="!showHeader"></app-header-mini>
    <main id="main" class="flex-1 px-12 pt-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
<ngx-spinner size="medium" [type]="spinnerType" style="z-index: 10000;"></ngx-spinner>

